/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Visibility_VisibleInputs */

const en_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible`)
};

const fr_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible`)
};

const de_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbar`)
};

const it_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibile`)
};

const ru_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видимый`)
};

const es_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible`)
};

const zh_cn2_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可见的`)
};

const ja_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見える`)
};

const hi_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्यमान`)
};

const pt_pt2_style_guide_manager_visibility_visible = /** @type {(inputs: Style_Guide_Manager_Visibility_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visível`)
};

/**
* | output |
* | --- |
* | "Visible" |
*
* @param {Style_Guide_Manager_Visibility_VisibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_visibility_visible = /** @type {((inputs?: Style_Guide_Manager_Visibility_VisibleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Visibility_VisibleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_visibility_visible(inputs)
	if (locale === "de") return de_style_guide_manager_visibility_visible(inputs)
	if (locale === "it") return it_style_guide_manager_visibility_visible(inputs)
	if (locale === "ru") return ru_style_guide_manager_visibility_visible(inputs)
	if (locale === "es") return es_style_guide_manager_visibility_visible(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_visibility_visible(inputs)
	if (locale === "ja") return ja_style_guide_manager_visibility_visible(inputs)
	if (locale === "hi") return hi_style_guide_manager_visibility_visible(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_visibility_visible(inputs)
	return en_style_guide_manager_visibility_visible(inputs)
});